import { render } from "./LogPerangkatAll.vue?vue&type=template&id=f6f686ea"
import script from "./LogPerangkatAll.vue?vue&type=script&lang=js"
export * from "./LogPerangkatAll.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vitechasia/Documents/Kantor/project_nuxt/vuess/vtadesk-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__